import { Component, Inject, ViewChild } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { DropdownComponent } from 'src/app/components/misc/dropdown.component'
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component'
import { DropdownOption } from 'globals/store/programs.data'
import { PerformerSessionInfo } from 'src/app/store/reselectors/performerSponsors.reselector'

@Component({
    selector: 'performer-assign-synopsis-dialog',
    template: `

<div #dialog class="joi-dialog">
  <div #content class="wrapper-content fitContent" mat-dialog-content >
    <h3>{{data.session.title}}</h3>
    <div style="margin-top: 15px;">Receive session information from:</div>
    <dropdown
      [selections]="data.performers"
      [selected]="data.performer" 
      [fullSpread]="false"
      (select)="selectPerformer($event)"
    ></dropdown>
  </div>
  <div class="menu-buttons" mat-dialog-actions >
    <button mat-button (click)="dialogRef.close()">CANCEL</button>
    <button mat-button color="primary" (click)="done()">APPLY</button>
  </div>
</div>
  `,
    styleUrls: ['./../../components/wrappers/dialog-wrapper.scss'],
    styles: [`
    dropdown { display: block; margin-top: 10px; }
  `],
    standalone: true,
    imports: [DropdownComponent],
})
export class PerformerAssignSynopsisDialogComponent {

  @ViewChild(DialogWrapperComponent) dialogWrapper : DialogWrapperComponent

  constructor(
    public dialogRef: MatDialogRef<PerformerAssignSynopsisDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: PerformerAssignSynopsisDialogData
  ) { }

  done() {
    this.dialogRef.close( this.data.performer )
  }
  selectPerformer(performer){
    this.data.performer = performer;
  }

  resizeDialog() {
    this.dialogWrapper.fitChildrenWithDelay(100)
  }

}

export interface PerformerAssignSynopsisDialogData {
  session:PerformerSessionInfo
  performer:DropdownOption
  performers:DropdownOption[]
}